import React, { FC } from "react";
import MuiSwitch from "@material-ui/core/Switch";

export type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

const Switch: FC<Props> = (props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!props.onChange) return;
    props.onChange(event.target.checked);
  };

  return <MuiSwitch value={props.value} onChange={handleChange} />;
};

export default Switch;
